<template>
  <BaseModal
    ref="BaseModal"
    @confirm="confirm"
    class="full-modal"
    @close="close"
  >
    <slot></slot>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal/index.vue'
export default {
  name: 'SelectModal',
  components: { BaseModal },
  data() {
    return {}
  },
  methods: {
    // 显示弹窗
    async show(options = {}) {
      this.$refs.BaseModal.show(options)
    },
    async confirm(close) {
      this.$emit('confirm', close)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.full-modal {
  ::v-deep .el-dialog {
    top: 0 !important;
  }
  ::v-deep .el-dialog__header {
    .right {
      z-index: 999;
    }
  }
  ::v-deep .el-dialog__headerbtn {
    z-index: 999;
    .el-dialog__close {
      font-size: 28px;
      color: #000;
    }
  }
  ::v-deep .el-dialog__body {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
}
</style>
